import React from 'react';
import FolderOpenRoundedIcon from '@mui/icons-material/FolderOpenRounded';
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkIcon from '@mui/icons-material/Link';
import '../../styles/sections/projects/OtherProjects.css';
import { Fade } from 'react-awesome-reveal';

const isMobile = window.innerWidth < 600;

interface ProjectInfo {
  desc: string;
  techStack: string;
  link: string;
  open?: string;
}

interface ProjectsData {
  [key: string]: ProjectInfo;
}

export const OtherProjects: React.FC = () => {
  const projects: ProjectsData = {
    'DFIC Quant Group': {
      desc: 'Head of the DFIC Quant Team. Stat arb and HFT crypto focused.',
      techStack: 'Python, GO, pandas',
      link: 'https://github.com/DFIC-Quant-Fund',
      open: 'https://dfic-fund.streamlit.app/',
    },
    'orbitwatch.xyz': {
      desc: 'Satellite imagery labeling platform powered by crowd-sourcing and machine learning.',
      techStack: 'Python, PostgreSQL, AWS',
      link: 'https://github.com/OKKM-insights',
      open: 'https://orbitwatch.xyz/',
    },
    'Years.Today': {
      desc: 'Take a glimpse into what people were sharing on this day a decade ago.',
      techStack: 'Typescript, Python, node.js',
      link: 'https://github.com/years-today',
      open: 'https://years.today/',
    },
    'ASL Lyrics': {
      desc: 'Song to ASL translator, created at UC Berkeley AI Hackathon 2024',
      techStack: 'React, OpenAI, node.js',
      link: 'https://github.com/OlegGlo/TextToSign',
      open: 'https://sign.mt/',
    },
    TeachAI: {
      desc: 'An AI driven lesson planner framework created at DeltaHacks 9.',
      techStack: 'React, node.js, Python',
      link: 'https://github.com/OlegGlo/teachAI',
      open: 'https://teach-ai.netlify.app/',
    },
    'Web Scraper Tool': {
      desc: 'An application created for personal use to check an online store for product restocks',
      techStack: 'Python, Selenium, Bash/UNIX',
      link: 'https://github.com/OlegGlo/ikea-web-scraper',
    }
    // 'Discord Server Management System': {
    //   desc: 'A system that assists server owners in managing and processing users support tickets and other requests.',
    //   techStack: 'Python, Discord API, Bash/UNIX',
    //   link: 'https://github.com/404',
    // },
    // 'Bulk SMS sender': {
    //   desc: 'A Python script that automates the sign up process for a wide variety of third party services.',
    //   techStack: 'Python, PySocks',
    //   link: 'https://github.com/404',
    //   open: '',
    // },
  };

  const renderProjectCard = (key: string, i: number) => (
    <li className="projects-card" key={i}>
      <div className="card-header">
        <div className="folder-icon">
          <FolderOpenRoundedIcon style={{ fontSize: 35 }} />
        </div>
        <a
          className="github-icon"
          style={{ opacity: isMobile ? 1 : undefined }}
          href={projects[key].link}
        >
          <GitHubIcon style={{ fontSize: 35 }} />
        </a>
        {projects[key].open && (
          <a
            className="link-icon"
            style={{ opacity: isMobile ? 1 : undefined }}
            href={projects[key].open}
          >
            <LinkIcon style={{ fontSize: 35 }} />
          </a>
        )}
      </div>
      <div className="card-title">{key}</div>
      <div className="card-desc">{projects[key].desc}</div>
      <div className="card-tech">{projects[key].techStack}</div>
    </li>
  );

  if (isMobile) {
    return (
      <section className="otherProjectsBackground">
        <div className="otherProjectsFocus">
          <div className="otherProjectsFocusTitle">
            <h1 className="sectionNumber">03.</h1>
            <h2 className="sectionTitle">Other projects</h2>
          </div>
          <div className="project-container">
            <ul className="projects-grid">
              {Object.keys(projects).map((key, i) => renderProjectCard(key, i))}
            </ul>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="otherProjectsBackground">
      <div className="otherProjectsFocus">
        <div className="otherProjectsFocusTitle">
          <h1 className="sectionNumber">03.</h1>
          <h2 className="sectionTitle">Other projects</h2>
        </div>
        <div className="project-container">
          <ul className="projects-grid">
            {Object.keys(projects).map((key, i) => (
              <Fade
                key={key}
                direction="up"
                triggerOnce={isMobile}
                delay={isMobile ? 250 : 150 + i * 100}
              >
                {renderProjectCard(key, i)}
              </Fade>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
